import React, { useEffect, useMemo, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import useSearch from "hooks/useSearch"
import useReportColumns from "hooks/useReportColumns"
import { REPORT_COLUMN_KEYS } from "config/reportColumnDefinitions"
import {
  exportMonitorTransactions,
  getMonitorTransactions,
} from "store/monitor-reports/monitor-report-action"
import {
  getMonitorIps,
  getMonitorItemCategories,
  getMonitorWarehouses,
} from "store/monitor-dashboard/monitor-dashboard-action"
import MonitorTransactionListComponent from "components/MonitorReports/Transaction"

const MonitorTransactionList = () => {
  // Meta Title
  document.title = "Transactions"

  const dispatch = useDispatch()

  // Retrieve transactins data from Redux store
  const transactions = useSelector(
    state => state.monitorReports.monitorTransactions
  )

  // Current status of the export process for the report, retrieved from the Redux store
  const exportTransaction = useSelector(
    state => state.monitorReports.monitorExportTransaction
  )
  const [search, setSearch] = useState(null)
  const [pageNumber, setPageNumber] = useState(20)
  const [according, setAccording] = useState({ order: "desc", name: "date" })
  const [advnacedSearch, setAdvancedSearch] = useState({})
  const { columns, visibleColumns, visibleKeys, toggleColumn } = useReportColumns(
    REPORT_COLUMN_KEYS.MONITOR_TRANSACTION
  )


  // Updates search value when a new search is performed
  const onSearchHandler = value => {
    setSearch(value)
  }

  // Fetches new data when a page number is clicked
  const onPageClick = link => {
    dispatch(
      getMonitorTransactions(
        link.url,
        pageNumber,
        according,
        search,
        advnacedSearch
      )
    )
  }

  // Updates the number of rows displayed based on user selection (e.g., 10, 20, 50)
  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  // Updates the ordering based on user selection
  const onChangeOrdering = value => {
    if (value.order) {
      setAccording(prev => {
        return { ...prev, order: value.order }
      })
    }
    if (value.name) {
      setAccording(prev => {
        return { ...prev, name: value.name }
      })
    }
  }

  // Custom Search Hook called everytime search updates
  useSearch(
    getMonitorTransactions(
      undefined,
      undefined,
      undefined,
      search,
      advnacedSearch
    ),
    search
  )
  // fetch new data based page number or according changes
  useEffect(() => {
    dispatch(
      getMonitorTransactions(
        undefined,
        pageNumber,
        according,
        search,
        advnacedSearch
      )
    )
  }, [pageNumber, according])

  // fetch needed data for filter select box
  useEffect(() => {
    dispatch(getMonitorItemCategories())
    dispatch(getMonitorWarehouses())
    dispatch(getMonitorIps())
  }, [])

  // Executes when the advanced search form is submitted
  const onAdvancedSearchSubmit = data => {
    setAdvancedSearch(data)
    dispatch(
      getMonitorTransactions(undefined, undefined, undefined, search, data)
    )
  }

  // Trigger export process when Export button is clicked
  const onExportBtnClick = () => {
    dispatch(exportMonitorTransactions(pageNumber, according, search, advnacedSearch, visibleKeys))
  }

  return (
    <React.Fragment>
      <Breadcrumbs title={"Monitor"} breadcrumbItem={"Transactions"} />

      {/* Monitor Transaction List Component  */}
      <MonitorTransactionListComponent
        data={transactions?.data}
        error={transactions?.error}
        loading={transactions?.loading}
        onSearch={onSearchHandler}
        onChangeRowNumber={onChangeRowNumber}
        onChangeOrdering={onChangeOrdering}
        onAdvancedSearchSubmit={onAdvancedSearchSubmit}
        onExportBtnClick={onExportBtnClick}
        exportTransaction={exportTransaction}
        onPageClick={onPageClick}
        columns={columns}
        visibleColumns={visibleColumns}
        onToggleColumn={toggleColumn}
      />
    </React.Fragment>
  )
}

export default MonitorTransactionList
